import { DataQueryKey } from '../../../hooks/useDataQuery/dataQuery.types';
import { FindProductGridParamsToOffline } from '../../../modules/offline/offlineRequestAdapters/productGrid.repository.offlineAdapters';
import { UsedInOfflineMode } from '../../../modules/offline/types/UsedInOfflineMode';
import { OrderProductGridItem } from '../../../modules/orders/products/orderProducts.types';
import { SuggestedGridItem } from '../../../modules/orders/products/product/suggestedGrid/suggested-grid.interface';
import { AvailabilityEnum } from '../../../modules/products/ProductTypes';
import { OrderProductSelectedPack } from '../../../modules/products/details/productDetails.types';

export interface FindProductGridParams extends FindProductGridParamsToOffline {
  productColorId: string;
  availability: AvailabilityEnum;
  deliveryWindowId?: string | null;
  orderId?: string;
  kitId?: string;
}

export interface IProductGridKey {
  teamId?: string;
  queryKey: DataQueryKey;
  params: FindProductGridParams;
}

export interface FindProductGridOutput {
  grid: OrderProductGridItem[];
  suggestedGrid: SuggestedGridItem[];
  suggestedPacks: OrderProductSelectedPack[];
  hasValidPacks: boolean;
  selectedPacks: OrderProductSelectedPack[];
}

export const initialGridData: FindProductGridOutput = {
  grid: [],
  suggestedGrid: [],
  suggestedPacks: [],
  hasValidPacks: false,
  selectedPacks: [],
};

export interface GetFindProductGridKeyParams extends FindProductGridParams, UsedInOfflineMode {}

export interface UseFindProductGridProps extends FindProductGridParams, UsedInOfflineMode {
  enabled?: boolean;
  useDefaultPriceTableWhenOffline?: boolean;
  callback?: () => void;
}
